import React from "react";
import * as S from "./style";
import Logo from '../../../../app/js/components/loggedout/Header/logo';

const Footer = ({ showPurchaseFooter, passwordScreen }) => {
  return (
    <S.Wrapper showPurchaseFooter={showPurchaseFooter} passwordScreen = {passwordScreen}>
      <S.ImageWrapper showPurchaseFooter={showPurchaseFooter} passwordScreen={passwordScreen}>
        <Logo showWhiteLogo={showPurchaseFooter} />
      </S.ImageWrapper>

      <S.FooterNotes showPurchaseFooter={showPurchaseFooter}>
        <S.LinkBox>
          {/* [AI GENERATED CODE] - Added Cookie Policy link after Privacy Policy */}
          <a href="/terms-of-use">Terms of use</a> | <a href="/privacy">Privacy Policy</a> | <a href="/cookies_info_setting">Cookie Policy and Preference Center</a>
        </S.LinkBox>
        <p>StudyPad &amp; SplashLearn are registered Trademarks of StudyPad, Inc.</p>
      </S.FooterNotes>
    </S.Wrapper>
  )
}

export default Footer;